<script>
  export default {
    name: 'screen-new-modal',

    data () {
      return {
        screen: {}
      }
    },

    methods: {
      handleOk (e) {
        e.preventDefault()

        this.$store.dispatch('screens/addScreen', this.screen).then(() => {
          this.$refs.modal.hide()
          this.screen = {}
        }).catch((err) => {
          console.log('Unable to add screen', err)
        })
      }
    },

    created () {
      this.$emit('update:title', 'New Screen')
      this.$emit('update:ok-title', 'Save & Continue')
    }
  }
</script>

<template>
  <b-card-body>
  </b-card-body>
</template>
